import React, { useState } from 'react'
import { ValueChangeDetails } from '@zag-js/select'
import { TbChevronDown } from 'react-icons/tb'

import { css } from 'styled-system/css'
import { Input } from 'ui-kit/input'
import { Select as SelectUiKit, createListCollection } from 'ui-kit/select'

import { Item, LoadingItem, ValueText } from './chunks'
import { ComboboxProps, SelectItemType } from './types'

const positioningProps = {
  hideWhenDetached: true,
  sameWidth: true,
  strategy: 'fixed',
}

export function Combobox({
  label,
  placeholder,
  items,
  value,
  onValueChange,
  onSearchInputChange,
  loading,
  IndicatorIconComponent = <TbChevronDown />,
  ItemTextComponent,
  TriggerTextComponent,
  positioning = {},
  ...props
}: ComboboxProps) {
  const [searchValue, setSearchValue] = useState('')
  const collection = createListCollection({ items })

  const selectedValue = value ? [value.value] : undefined

  function handleValueChange({ items }: ValueChangeDetails<SelectItemType>) {
    onValueChange?.(items?.[0])
  }

  function handleSearchInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value
    setSearchValue(value)
    onSearchInputChange?.(value)
  }

  return (
    <SelectUiKit.Root
      lazyMount
      unmountOnExit
      collection={collection}
      value={selectedValue}
      onValueChange={handleValueChange}
      positioning={Object.assign({}, positioningProps, positioning)}
      {...props}
    >
      {!!label && <SelectUiKit.Label>{label}</SelectUiKit.Label>}
      <SelectUiKit.Control>
        <SelectUiKit.Trigger>
          <ValueText
            value={value}
            placeholder={placeholder}
            TriggerTextComponent={TriggerTextComponent}
            ItemTextComponent={ItemTextComponent}
          />
          {IndicatorIconComponent}
        </SelectUiKit.Trigger>
      </SelectUiKit.Control>
      <SelectUiKit.Positioner>
        <SelectUiKit.Content>
          <SelectUiKit.ItemGroup>
            <Input
              size={'sm'}
              value={searchValue}
              onChange={handleSearchInputChange}
              className={css({
                marginBlockEnd: 1,
                position: 'sticky',
                top: 0,
                zIndex: 'sticky',
                backgroundColor: 'bg.canvas',
              })}
            />
            {loading && <LoadingItem />}
            {collection.items.map((item) => (
              <Item
                item={item}
                key={item.value}
                ItemTextComponent={ItemTextComponent}
              />
            ))}
          </SelectUiKit.ItemGroup>
        </SelectUiKit.Content>
      </SelectUiKit.Positioner>
      <SelectUiKit.HiddenSelect />
    </SelectUiKit.Root>
  )
}
